import React from 'react';

// components
import CloseIcon from '../../icons/CloseIcon';

interface ProjectsBannerProps {
  title: string;
  description: string;
  isVisible: boolean;
  onClose: () => void;
  isDarkMode: boolean;
}

const ProjectsBanner: React.FC<ProjectsBannerProps> = ({
  title,
  description,
  isVisible,
  onClose,
  isDarkMode,
}) => {
  if (!isVisible) return null;

  return (
    <div className="w-full h-full bg-[#dedede] rounded-lg shadow-md p-4 dark:bg-[#595959] dark:text-[#eeeeee]">
      <div className="projects-banner__content flex flex-col gap-1">
        <div className="flex justify-end">
          <span
            className="cursor-pointer bg-[#585858] rounded-lg p-1 hover:opacity-80 transition-opacity duration-200 dark:bg-[#ffffff]"
            onClick={onClose}
          >
            <CloseIcon fill={isDarkMode ? '#595959' : '#ffffff'} />
          </span>
        </div>
        <div className="projects-banner__header font-fam-open-sans mt-[-16px] w-full max-w-[835px] mx-auto">
          <h2 className="projects-banner__title font-bold text-xl text-center uppercase leading-[24px]">
            {title}
          </h2>
        </div>
        <p className="projects-banner__description text-center leading-[16px] italic w-full max-w-[835px] mx-auto">
          {description}
        </p>
      </div>
    </div>
  );
};

export default ProjectsBanner;
